import { render, staticRenderFns } from "./two_table.vue?vue&type=template&id=987fc78e&"
import script from "./two_table.vue?vue&type=script&lang=js&"
export * from "./two_table.vue?vue&type=script&lang=js&"
import style0 from "./two_table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports